module.exports = __webpack_public_path__ + "img/1-12.59a432ba.png";